import { useContext, useEffect, useState } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import Pager from "components/ui/controls/pager/pager";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import StateBox from "components/ui/controls/state-box/state-box";

function ContratsPrevoyanceSelect(props) {
  const context = useContext(AppContext);

  const [typeContrat, setTypeContrat] = useState("prevoyance");
  const handleClick = (evt) => {
    setTypeContrat(evt.target.value);
  };
  useEffect(() => {
    setTypeContrat("prevoyance");
  }, [props.visible]);
  return (
    <>
      <Pager
        pages={[
          {
            content: (
              <Column center fill pad>
                <CardBox>
                  <Column>
                    {context.state[props.Outil+'Statut'+props.ClientConjoint] === "TNS Article 62" ||context.state[props.Outil+'Statut'+props.ClientConjoint] === "TNS individuel"
                      ? context.state[props.Outil+'ContratEnregistre'+props.ClientConjoint].length < 3 && (
                          <Row tpad>
                            <StateBox label="Contrat de prévoyance" inline checked="prevoyance" value={typeContrat === "prevoyance"} onClick={handleClick} />
                          </Row>
                        )
                      :context.state[props.Outil+'ContratEnregistre'+props.ClientConjoint].length === 0 && (
                          <Row tpad>
                            <StateBox label="Contrat de prévoyance" inline checked="prevoyance" value={typeContrat === "prevoyance"} onClick={handleClick} />
                          </Row>
                        )}
                      <Row tpad>
                        <StateBox label="Contrat de santé" inline checked="sante" value={typeContrat === "sante"} onClick={handleClick} />
                      </Row>
                  </Column>
                </CardBox>
              </Column>
            ),
          },
        ]}
        page={0}
        navButtons={{
          validate: {
            onClick: () => {
              // context.handleAddCotisationManuelle("");
              props.onClose(typeContrat);
            },
          },
        }}
      />
    </>
  );
}

export default ContratsPrevoyanceSelect;
